<mat-radio-group [(ngModel)]="radio">
    <mat-radio-button
        *ngFor="let radio of settings.radiobuttons"
        [value]="radio"
    >
        {{radio}}
    </mat-radio-button>
</mat-radio-group>
